import {
    TOGGLE_SPECIFICATION_SLIDER,
    RESET_FORM_DATA,
    RESET_SPEC_ERRORS,
    HANDLE_ON_INPUT_CHANGE,
    UPDATE_SPECIFICATION_DATA
} from '../actions/types';

export const initialState = {
    initPuvSpecAttributes: [],
    editablePuvSpecAttributes:[],
    savedPuvSpecAttributes: [],
    initCustomSpecAttributes: [{key: {}, value: {}}],
    savedCustomSpecAttributes: [],
    specSliderState: false,
    aiFlow: false,
    productSmartFillSpec: [],
    prevCatSpec: {},
    isEnrichSpec:false,
}
function deepCopy(json){
    return JSON.parse(JSON.stringify(json))
}
export default (state = deepCopy(initialState), { type , payload }) => {
    switch(type){
        case UPDATE_SPECIFICATION_DATA:
            return {
                ...state,
                ...payload
            }

        case RESET_FORM_DATA:
            if(payload){
                return deepCopy({
                    ...initialState,
                    prevCatSpec: payload?.prevData ? {...state} : {}
                })
            }else{
                return {
                    ...state,
                    savedPuvSpecAttributes: [...state.savedPuvSpecAttributes],
                    savedCustomSpecAttributes: [...state.savedCustomSpecAttributes],
                    editablePuvSpecAttributes: [...(state.savedPuvSpecAttributes.length? state.savedPuvSpecAttributes : state.initPuvSpecAttributes)],
                    initCustomSpecAttributes: [{key: {}, value: {}}],
                    specSliderState: false,
                    aiFlow: false
                }
            }
        case RESET_SPEC_ERRORS:
            let editablePuvSpecAtt = deepCopy(state.editablePuvSpecAttributes);
            const resetErrArr = editablePuvSpecAtt.map(cur => (cur.userInput.error = '' , cur ))
            return {
                ...state,
                editablePuvSpecAttributes: resetErrArr
            }

        case TOGGLE_SPECIFICATION_SLIDER:
            return {
                ...state,
                specSliderState: payload?.specSlider,
                aiFlow: payload?.aiFlow
            }

        case HANDLE_ON_INPUT_CHANGE:{
            const tempState = [...state.editablePuvSpecAttributes];
            const { item, parentIndex } = payload;
            tempState[parentIndex] = item;

            return {
                ...state,
                editablePuvSpecAttributes: tempState
            };

        }

        default: {
            return state;
        }

    }
}
